export const siteSettings = {
  name: "Accesx Market",
  link: "https://accesxmarket.com",
  email: "support@accesxmarket.com",
  appLink: "https://app.accesxmarket.com",
};
